export default "__VITE_ASSET__DuDa4VXy__"